import styled from "styled-components";

export default styled.div`
  width: 100%;
  height: 100px;
  display: grid;
  place-items: center;
  color: var(--text2);
  font-size: 16px;
`;
